import { aboutData } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          关于平台
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-12 max-w-[600px] mx-auto">
          了解国产91视频的定位与使命
        </p>

        <div className="max-w-[900px] mx-auto bg-background-50 border border-background-200/70 rounded-2xl p-6 md:p-10">
          <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950 mb-4">
            {aboutData.title}
          </h3>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
            {aboutData.description}
          </p>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
            {aboutData.highlights.map((item) => (
              <div key={item.label} className="text-center p-4 bg-background-100 rounded-xl">
                <div className="font-heading text-xl md:text-2xl font-extrabold text-primary-500 mb-1">
                  {item.value}
                </div>
                <div className="text-xs text-foreground-500">{item.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}